import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const PhoneButton = styled(Button)(({ theme }) => ({
	' .MuiButton-startIcon': {
		marginRight: theme.spacing(0.5),
	},
	' .MuiButton-endIcon': {
		fontSize: '0.625rem',
		marginLeft: theme.spacing(0.5),
	},
}));
